import styles from '/builds/servicebund/servicebund-websites/.build/releases/1/DistributionPackages/Servicebund.RodeoSteakDe/Resources/Private/Fusion/Presentation/Component/Atom/SvgIcon/SvgIcon.css';

export const prototypeName = 'Servicebund.RodeoSteakDe:Component.Atom.SvgIcon';
export {styles};